import { Injectable, Injector } from '@angular/core';
import { HttpEvent, HttpRequest, HttpHandler, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { AuthService, AuthResult } from './auth.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private injector: Injector, private authService: AuthService) {}

  intercept(
    req: HttpRequest<any>, 
    next: HttpHandler
    ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      // riprova prima di sollevare l'errore
      //retry(1),

      catchError((error: HttpErrorResponse) => {
        // console.log(`HttpError: ${JSON.stringify(error )}`)
        if (error.status === 401) {
          // recupero l'autenticazione
          this.authService.getAuthentication().then((authResult: AuthResult) => {
            // console.log(`AuthResult after error - AccessToken: ${authResult.accessToken}- RefreshToken: ${authResult.refreshToken} - ExpireDate: ${authResult.expireAt} - ExpireIn: ${authResult.expiresIn}`)
            req = req.clone({
              setHeaders: {
                Authorization: 'Bearer ' + authResult.accessToken
              }
            });
            // effettuo la chiamata
            return next.handle(req).subscribe(
              ok => {
                // console.log(`next Handler OK: ${JSON.stringify(ok)}`);
              },
              ko => {
                // console.log(`next Handler KO: ${JSON.stringify(ko)}`);
                return throwError(ko);
              }
            );
          });
        }
        return throwError(error);
      })
    );
  }
}
